import type { GivingHistoryItem } from '@sola/schema/dotcom/proxy-api/givingHistory.ts';
import type {
  GraphQLCommitment,
  GraphQLPledge,
} from '@sola/schema/dotcom/supporters/schema.generated.ts';

export enum GivingTypeEnum {
  Stocks = 'Stocks',
}

export type GivingItemWithCommitment = GivingHistoryItem & {
  commitment?: GraphQLCommitment;
  pledge?: GraphQLPledge;
};
